/*
 * Single field filter
 */
class FilterField {
	constructor(input) {
		this.field = ko.observable();
		this.operator = ko.observable();
		this.value = ko.observable();

		this.fieldName = ko.pureComputed(() => {
			if (typeof (this.field()) == 'object')
			{
				return this.field()?.field ?? this.field()?.name;
			}
			else
			{
				return this.field();
			}
		});

		this.fieldType = ko.pureComputed(() => {
			let fieldType = ko.unwrap(this.field?.()?.type) ?? 'text';

			if (fieldType?.length > 0)
				return fieldType;
			else
				return 'text';
		});

		this.filterString = ko.pureComputed(() => {
			const field = this.fieldName();
			const operator = this.operator();
			const value = this.value();

			return `${field} ${operator} ${value}`;
		});

		this.set(input);
	}

	set(input) {
		input = ko.mapping.toJS(input ?? {});

		this.field(input.field ?? input.f);
		this.operator(input.operator ?? input.op ?? input.o ?? '=');
		this.value(input.value ?? input.v ?? '');
	}

	get() {
		return {
			field: this.fieldName(),
			operator: this.operator(),
			value: this.value()
		};
	}
}
export default FilterField;

